import React, { useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { isEmpty, set } from 'lodash';
import { RenderPurchaseOrderDetail } from './RenderPurchaseOrderDetail';
import { RenderOrderDetail } from './RenderOrderDetail';
import { RenderColourSection } from './RenderColourSection/index';
import { RenderShippingDetails } from './RenderShippingDetails';
import { RenderTermsAndCondition } from './RenderTermsAndCondition';
import { RenderCompanyDetails } from './RenderCompanyDetails';
import { RenderGrandTotal } from './RenderGrandTotal';
import { usePurchaseOrderState } from '../PurchaseOrderContext';
import { checkArray } from '../../../../Components/helper';
import { Section, ElementTemplate } from '../TemplateComponent';
import { RenderSupplierFactoryDetails } from './RenderSupplierFactoryDetails';
import { commonPath } from '../fieldPath';

export function RightSideSection() {
  const {
    UserDetails: { isSupplierLoggedIn },
    purchaseOrderData: { purchaseOrderDetails },
    BOMConfigDetails: { productDetails },
  } = useSelector((reduxState) => reduxState);

  const {
    purchaseOrderState: { templateJsonSchema, loader },
    setPurchaseOrderState,
    purchaseOrderState,
    disableConditions,
    fromPreview,
    isPublicPoPage,
    poAddEditAccess,
  } = usePurchaseOrderState();

  useEffect(() => {
    if (!isEmpty(templateJsonSchema)) {
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        templateJsonSchema,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateJsonSchema]);

  const handleSectionChange = async (value, keyName) => {
    const copyState = purchaseOrderState;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    set(purchaseOrderState, `${locate[0]}.hasError.status`, false);
    await set(copyState, keyName, value);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const templateRendering = (temp, i) => {
    switch (temp?.key) {
      case 'Ratio_Pack':
        return (
          temp?.colorWay && (
            <Col lg={12} key={`RenderColourSection_${temp?.key}_${temp?.id}_${i}`}>
              <RenderColourSection data={temp} parentI={i} totalData={purchaseOrderDetails} isProductArchived={productDetails?.isArchived} />
            </Col>
          )
        );
      case 'A_F_Details':
        return (
          <Col lg={12} key={`RenderSupplierFactoryDetails_${temp?.key}_${temp?.id}_${i}`}>
            <RenderSupplierFactoryDetails data={temp} pIndex={i} isProductArchived={productDetails?.isArchived} />
          </Col>
        );
      case 'Shipping_Details':
        return (
          <Col lg={12} key={`RenderShippingDetails_${temp?.key}_${temp?.id}_${i}`}>
            <RenderShippingDetails data={temp} pIndex={i} />
          </Col>
        );
      case 'Grand_Total':
        return (
          <Col lg={12} key={`RenderGrandTotal_${temp?.key}_${temp?.id}_${i}`}>
            <RenderGrandTotal isProductArchived={productDetails?.isArchived} />
          </Col>
        );
      case 'Terms_conditions':
        return (
          <Col lg={12} key={`RenderTermsAndCondition_${temp?.key}_${temp?.id}_${i}`}>
            <RenderTermsAndCondition data={temp} pIndex={i} isProductArchived={productDetails?.isArchived} />
          </Col>
        );
      case 'order_details':
        return (
          <Col lg={12} key={`RenderOrderDetail_${temp?.key}_${temp?.id}_${i}`}>
            <RenderOrderDetail />
          </Col>
        );
      case 'Company_Details':
        return (
          <Col lg={12} key={`RenderCompanyDetails_${temp?.key}_${temp?.id}_${i}`}>
            <RenderCompanyDetails data={temp} pIndex={i} isProductArchived={productDetails?.isArchived} />
          </Col>
        );
      default:
        return (
          <Col lg={12} key={`Section_${temp?.key}_${temp?.id}_${i}`}>
            {temp?.key === 'Section' && (
              <Section prop={temp}>
                <Row className="span_font_size">
                  {temp?.columns.map((column, colIndex) => {
                    return (
                      <Col lg={6} key={colIndex}>
                        {column?.map((col, colChildIndex) => {
                          return (
                            <div className="py-1" key={colChildIndex}>
                              <ElementTemplate
                                {...col}
                                keys={col?.key}
                                onChange={handleSectionChange}
                                pIndex={i}
                                requiredField={col?.required}
                                disable
                                error={col?.hasError}
                                options={col?.options}
                                placeHolder={col?.label}
                                isProductArchived={productDetails?.isArchived}
                                value={col?.value}
                                path={
                                  col?.key === 'Check_Boxes'
                                    ? commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS_CHECKBOX
                                    : commonPath(i, colIndex, colChildIndex).COMPANY_DETAILS
                                }
                              />
                            </div>
                          );
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </Section>
            )}
          </Col>
        );
    }
  };
  return (
    <Container className="py-4 pl-5" fluid>
      <Row>
        <Col lg={12}>
          <RenderPurchaseOrderDetail />
        </Col>
        {templateJsonSchema?.filter((element) => element?.key === 'order_details').length === 0 && (
          <Col lg={12}>
            <RenderOrderDetail />
          </Col>
        )}
      </Row>
      {checkArray(templateJsonSchema) &&
        templateJsonSchema.map((temp, i) => {
          return <Row key={`${temp?.key}_${temp?.id}_${i}`}>{templateRendering(temp, i)}</Row>;
        })}
    </Container>
  );
}

export default RightSideSection;
